import DETH_ABI from "../ABI/DETH_ABI.json";
import { publicEnv, publicInteger } from "../lib/runtimeEnv";

const lower = (value) => value ? value.toLowerCase() : "";
const hexChainId = (chainId) => `0x${chainId.toString(16)}`;

const ethChainId = publicInteger(
  "REACT_APP_ETH_CHAIN_ID",
  process.env.REACT_APP_ETH_CHAIN_ID,
  1,
);
const bscChainId = publicInteger(
  "REACT_APP_BSC_CHAIN_ID",
  process.env.REACT_APP_BSC_CHAIN_ID,
  56,
);

export const network = {
  ETH: {
    currencySymbol: "ETH",
    tokenSymbol: "WETH",
    tokenABI: { WETH: DETH_ABI },
    tokenAddr: {
      WETH: lower(publicEnv("REACT_APP_ETH_TOKEN_ADDRESS", process.env.REACT_APP_ETH_TOKEN_ADDRESS)),
    },
    singleContract: lower(publicEnv("REACT_APP_ETH_SINGLE_CONTRACT", process.env.REACT_APP_ETH_SINGLE_CONTRACT)),
    multipleContract: lower(publicEnv("REACT_APP_ETH_MULTIPLE_CONTRACT", process.env.REACT_APP_ETH_MULTIPLE_CONTRACT)),
    TradeContract: lower(publicEnv("REACT_APP_ETH_TRADE_CONTRACT", process.env.REACT_APP_ETH_TRADE_CONTRACT)),
    literatureContract: lower(publicEnv("REACT_APP_ETH_LITERATURE_CONTRACT", process.env.REACT_APP_ETH_LITERATURE_CONTRACT)),
    BNBPROVIDER: publicEnv("REACT_APP_ETH_RPC_URL", process.env.REACT_APP_ETH_RPC_URL),
    networkVersion: String(ethChainId),
    chainId: hexChainId(ethChainId),
    Chainid: ethChainId,
    name: ethChainId === 1 ? "Ethereum" : "Ethereum Testnet",
    label: "ETH",
    value: "ETH",
    trade: lower(publicEnv("REACT_APP_ETH_TRADE_CONTRACT", process.env.REACT_APP_ETH_TRADE_CONTRACT)),
    EvmName: "ETHEREUM",
  },
  BSC: {
    currencySymbol: "BNB",
    tokenSymbol: "WBNB",
    tokenABI: { WBNB: DETH_ABI },
    tokenAddr: {
      WBNB: lower(publicEnv("REACT_APP_BSC_TOKEN_ADDRESS", process.env.REACT_APP_BSC_TOKEN_ADDRESS)),
    },
    singleContract: lower(publicEnv("REACT_APP_BSC_SINGLE_CONTRACT", process.env.REACT_APP_BSC_SINGLE_CONTRACT)),
    multipleContract: lower(publicEnv("REACT_APP_BSC_MULTIPLE_CONTRACT", process.env.REACT_APP_BSC_MULTIPLE_CONTRACT)),
    TradeContract: lower(publicEnv("REACT_APP_BSC_TRADE_CONTRACT", process.env.REACT_APP_BSC_TRADE_CONTRACT)),
    literatureContract: lower(publicEnv("REACT_APP_BSC_LITERATURE_CONTRACT", process.env.REACT_APP_BSC_LITERATURE_CONTRACT)),
    BNBPROVIDER: publicEnv("REACT_APP_BSC_RPC_URL", process.env.REACT_APP_BSC_RPC_URL),
    networkVersion: String(bscChainId),
    chainId: hexChainId(bscChainId),
    Chainid: bscChainId,
    name: bscChainId === 56 ? "BNB Smart Chain" : "BSC Testnet",
    label: "BNB",
    value: "BNB",
    EvmName: "BSC",
  },
};
